import React from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/zam/SmoothScroll";
import Nav from "@/components/zam/Nav";
import Hero from "@/components/zam/Hero";
import Marquee from "@/components/zam/Marquee";
import Services from "@/components/zam/Services";
import Process from "@/components/zam/Process";
import Booking from "@/components/zam/Booking";
import Trust from "@/components/zam/Trust";
import Faq from "@/components/zam/Faq";
import CtaStrip from "@/components/zam/CtaStrip";
import Footer from "@/components/zam/Footer";

export default function App() {
  return (
    <div className="App">
      <SmoothScroll />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Process />
        <Booking />
        <Trust />
        <Faq />
        <CtaStrip />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}
